// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  gap: 12px;
}

.loading-container.small {
  padding: 10px;
  gap: 8px;
}

.loading-container.large {
  padding: 40px;
  gap: 16px;
}

.spinner {
  border: 3px solid #f3f3f3;
  border-top: 3px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.loading-container.small .spinner {
  width: 20px;
  height: 20px;
  border-width: 2px;
}

.loading-container.medium .spinner {
  width: 30px;
  height: 30px;
  border-width: 3px;
}

.loading-container.large .spinner {
  width: 40px;
  height: 40px;
  border-width: 4px;
}

.loading-message {
  font-size: 14px;
  color: #666;
  text-align: center;
}

.loading-container.small .loading-message {
  font-size: 12px;
}

.loading-container.large .loading-message {
  font-size: 16px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/LoadingSpinner.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC","sourcesContent":[".loading-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 20px;\r\n  gap: 12px;\r\n}\r\n\r\n.loading-container.small {\r\n  padding: 10px;\r\n  gap: 8px;\r\n}\r\n\r\n.loading-container.large {\r\n  padding: 40px;\r\n  gap: 16px;\r\n}\r\n\r\n.spinner {\r\n  border: 3px solid #f3f3f3;\r\n  border-top: 3px solid #007bff;\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n}\r\n\r\n.loading-container.small .spinner {\r\n  width: 20px;\r\n  height: 20px;\r\n  border-width: 2px;\r\n}\r\n\r\n.loading-container.medium .spinner {\r\n  width: 30px;\r\n  height: 30px;\r\n  border-width: 3px;\r\n}\r\n\r\n.loading-container.large .spinner {\r\n  width: 40px;\r\n  height: 40px;\r\n  border-width: 4px;\r\n}\r\n\r\n.loading-message {\r\n  font-size: 14px;\r\n  color: #666;\r\n  text-align: center;\r\n}\r\n\r\n.loading-container.small .loading-message {\r\n  font-size: 12px;\r\n}\r\n\r\n.loading-container.large .loading-message {\r\n  font-size: 16px;\r\n}\r\n\r\n@keyframes spin {\r\n  0% { transform: rotate(0deg); }\r\n  100% { transform: rotate(360deg); }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
